import { Controller } from '@hotwired/stimulus'

// Onboarding Team step: add/remove invite rows from a <template>.
export default class extends Controller {
  static targets = ['rows', 'template']

  add() {
    this.rowsTarget.insertAdjacentHTML('beforeend', this.templateTarget.innerHTML)
  }

  remove(event) {
    event.target.closest('.bz-onb__invite-row')?.remove()
  }
}
